var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.5H19.5V18H24V15H19.5V10.5H16.5V15H12V18H16.5V22.5ZM12 31.5V28.5H6C5.175 28.5 4.46875 28.2063 3.88125 27.6188C3.29375 27.0312 3 26.325 3 25.5V7.5C3 6.675 3.29375 5.96875 3.88125 5.38125C4.46875 4.79375 5.175 4.5 6 4.5H30C30.825 4.5 31.5313 4.79375 32.1188 5.38125C32.7063 5.96875 33 6.675 33 7.5V25.5C33 26.325 32.7063 27.0312 32.1188 27.6188C31.5313 28.2063 30.825 28.5 30 28.5H24V31.5H12ZM6 25.5H30V7.5H6V25.5Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.847a4deee5c928fab27a093b6db9e233.svg";
export { ForwardRef as ReactComponent };